import {
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Injector,
  OnInit,
  ViewContainerRef,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  BehaviouralAssessmentGraphData,
  caseDetail,
  FunctionalAssessmentModelAnswer,
  FunctionalAssessmentModelResponse,
  FunctionalAssessmentQuestion,
  BehaviorFuncation,
} from '../assesment-fba.interface';
import { finalize, Observable, Subject, take, takeUntil } from 'rxjs';
import { DrawerService } from '../../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../../core/constants/drawer-ids.constant';
import {
  ApiResponses,
  CaseBehaviour,
  CaseDetailModel,
} from '../../../../insights.interface';
import { LookupItem } from '../../../../../../core/models/lookup.models';
import { LoaderService } from '../../../../../../core/services/loader.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SvgIconComponent } from 'angular-svg-icon';
import { CommonModule } from '@angular/common';
import { NzRadioModule, NzRadioGroupComponent } from 'ng-zorro-antd/radio';
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonService } from '../../../../../../shared/services/common.service';
import { InsightsService } from '../../../../insights.service';
import {
  NzFormControlComponent,
  NzFormItemComponent,
  NzFormModule,
} from 'ng-zorro-antd/form';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import _ from 'lodash';
import { GenderReplacePipe } from '../../../../../../core/pipes/gender-replace.pipe';
import { ScreenerResultsGraphComponent } from '../screener-results-graph/screener-results-graph.component';
import { BehaviourFunction, InsightMode } from '../../../../insights.enums';
import { ErrorResponse } from '../../../../../../core/models/error.models';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { PrintFbaComponent } from '../print-fba/print-fba.component';
import { OrganizationModel } from '../../../../../organizations/organization.interface';
import { OrganizationService } from '../../../../../organizations/organization.service';
import { ManageBehaviorStrategiesComponent } from '../../manage-behavior-strategies/manage-behavior-strategies.component';
import { InsightsDataComponent } from '../../../insights-data/insights-data.component';
import { ViewBipDrawerNavigationService } from '../../shared/view-bip-drawer-navigation.service';
import { AuthService } from '../../../../../../core/services/auth.service';
import { CmsRoleAccessService } from '../../../../../../core/services/cms-role-access.service';
import { UserRole } from '../../../../../activity-dashboard/activity-dashboard.enums';
import { DrawerHeaderComponent } from '../../../../../../components/drawer-header/drawer-header.component';
import {
  BipTemplateGatingService,
  BipTileSection,
} from '../../../../../../shared/services/bip-template-gating.service';
import { TemplateModel } from '../../../../../bip-template/bip-template.interface';

@Component({
  selector: 'app-fba-assessment',
  standalone: true,
  imports: [
    NzSpinModule,
    SvgIconComponent,
    CommonModule,
    NzFormControlComponent,
    NzFormControlComponent,
    NzFormModule,
    NzFormItemComponent,
    NzDividerModule,
    ReactiveFormsModule,
    NzRadioModule,
    NzRadioGroupComponent,
    GenderReplacePipe,
    ScreenerResultsGraphComponent,
    NzButtonModule,
    DrawerHeaderComponent,
  ],
  templateUrl: './fba-assessment.component.html',
  styleUrl: './fba-assessment.component.scss',
})
export class FbaAssessmentComponent implements OnInit, OnDestroy {
  @ViewChild('drawerTitleBehaviorStrategies')
  drawerTitleBehaviorStrategies!: TemplateRef<void>;
  @ViewChild('drawerTitleData') drawerTitleData!: TemplateRef<void>;
  behavior: CaseBehaviour = {} as CaseBehaviour;
  behaviourAssessment: FunctionalAssessmentModelAnswer[] =
    [] as FunctionalAssessmentModelAnswer[];
  caseDetail: CaseDetailModel = {} as CaseDetailModel;
  graphData: BehaviouralAssessmentGraphData[] =
    [] as BehaviouralAssessmentGraphData[];
  loading$: Observable<boolean>;
  isPrintLoading = false;
  isEdit = false;
  chartImage: string | null | undefined = null;
  fbaQuestionList!: FunctionalAssessmentQuestion[];
  private readonly destroy$ = new Subject<void>();
  BehaviourFunctionList: LookupItem[] = [];
  functionalAssessmentForm!: FormGroup;
  stepNumber = 0;
  currentQuestion = 0;
  isFinalStep = false;
  isUpdated = false;
  isNextLoading = false;
  isContinueProcessing = false;
  mode = InsightMode.VIEW;
  assesupdatedDate: string | null = null;
  userRoles: string[] = [];
  roleEnum = UserRole;
  allowManageAssessment = true;
  bipTemplate: TemplateModel | null = null;
  tileSection = BipTileSection;
  constructor(
    private readonly drawerService: DrawerService,
    private readonly fb: FormBuilder,
    private readonly loaderService: LoaderService,
    private readonly commonService: CommonService,
    private readonly insightService: InsightsService,
    private readonly genderReplacePipe: GenderReplacePipe,
    private readonly injector: Injector,
    private readonly viewContainerRef: ViewContainerRef,
    private readonly cd: ChangeDetectorRef,
    private readonly orgService: OrganizationService,
    private readonly viewBipDrawerNavigationService: ViewBipDrawerNavigationService,
    private readonly authService: AuthService,
    private readonly cmsRoleAccessService: CmsRoleAccessService,
    private readonly bipTemplateGatingService: BipTemplateGatingService
  ) {
    this.loading$ = this.loaderService.loading$;
    this.authService.userRoles$
      .pipe(takeUntil(this.destroy$))
      .subscribe(roles => {
        if (roles) {
          this.userRoles = roles;
          this.allowManageAssessment =
            this.cmsRoleAccessService.computeAllowFromCmsRole(this.userRoles, [
              this.roleEnum.CMSManager,
              this.roleEnum.CMSDataEntry,
              this.roleEnum.CMSBrowser,
            ]);
        }
      });
    this.functionalAssessmentForm = this.fb.group({
      questions: this.fb.array([]),
      selectedOptions: [[], Validators.required],
      isAssessedFunctions: [true],
      levelEscape: [''],
      levelAttention: [''],
      isLevelEscap: [false],
      isLevelAttention: [false],
    });
    this.setupDrawerSubscription();
    this.getBehaviourQuestionList();
  }

  /**
   * Returns an array of modified fields for the FBA answers (for audit logging).
   * Compares previous answers (oldAnswers) and new answers (newAnswers).
   * Each answer is { functionalAssessmentQuestionId, functionalAssessmentAnswerId }
   */
  private getAssessmentModifiedFields(
    oldAnswers: FunctionalAssessmentModelAnswer[],
    newAnswers: FunctionalAssessmentModelAnswer[]
  ): {
    field: string;
    label: string;
    oldValue: string | null;
    newValue: string | null;
  }[] {
    const studentName = this.caseDetail?.student?.firstName ?? '';
    const studentGender = this.caseDetail?.student?.gender ?? 'Not Specified';

    const getDisplayText = (text: string): string =>
      this.genderReplacePipe.transform(text, studentName, studentGender);

    const questionLookup = new Map(
      (this.fbaQuestionList || []).map(question => [question.id, question])
    );

    const getAnswerLabel = (
      questionId: number,
      answerId: number | null | undefined
    ): string | null => {
      if (!answerId) {
        return null;
      }

      const matchedAnswer = questionLookup
        .get(questionId)
        ?.functionalAssessmentAnswers?.find(answer => answer.id === answerId);

      const answerLabel = matchedAnswer?.answer ?? `Answer ${answerId}`;
      return getDisplayText(answerLabel);
    };

    // Map by questionId for fast lookup
    const oldMap = new Map(
      (oldAnswers || []).map(a => [
        a.functionalAssessmentQuestionId,
        a.functionalAssessmentAnswerId,
      ])
    );
    const newMap = new Map(
      (newAnswers || []).map(a => [
        a.functionalAssessmentQuestionId,
        a.functionalAssessmentAnswerId,
      ])
    );
    const modifiedFields: {
      field: string;
      label: string;
      oldValue: string | null;
      newValue: string | null;
    }[] = [];
    // For all questions in either old or new
    const allQuestionIds = Array.from(
      new Set([...Array.from(oldMap.keys()), ...Array.from(newMap.keys())])
    );
    for (const qid of allQuestionIds) {
      const oldAnswerId = oldMap.get(qid) ?? null;
      const newAnswerId = newMap.get(qid) ?? null;
      const oldVal = getAnswerLabel(qid, oldAnswerId);
      const newVal = getAnswerLabel(qid, newAnswerId);
      const questionLabel = getDisplayText(
        questionLookup.get(qid)?.question ?? `Question ${qid}`
      );

      if (oldVal !== newVal) {
        modifiedFields.push({
          field: `question_${qid}`,
          label: `${questionLabel}`,
          oldValue: oldVal,
          newValue: newVal,
        });
      }
    }
    return modifiedFields;
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<caseDetail>(DRAWER_IDS.FBA)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseDetail = params.caseDetail;
          this.behavior = params.behavior;
          this.chartImage = params.chartImage;
          this.mode = params.mode as InsightMode;
          this.loadBipTemplate();
        }
      });
  }

  private loadBipTemplate(): void {
    const bipTemplateId = this.caseDetail?.bipTemplateId;
    if (!bipTemplateId) {
      this.bipTemplate = null;
      return;
    }
    this.bipTemplateGatingService
      .getTemplate(bipTemplateId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(template => {
        this.bipTemplate = template;
        this.cd.detectChanges();
      });
  }

  ngOnInit() {
    this.getMasterData();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBehaviourAssessment() {
    this.insightService
      .getBehaviourAssessment(this.behavior.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          if (response.result) {
            this.assesupdatedDate = response.result.updatedDate ?? null;
            this.behaviourAssessment =
              response.result.functionalAssessmentAnswers;
            if (this.behaviourAssessment.length === 16) {
              this.insightService.assessmentSubject.next(
                this.behaviourAssessment
              );
            }
            this.cd.detectChanges();
            if (this.behaviourAssessment.length > 0) {
              this.patchFormWithAnswers();
            }

            this.currentQuestion =
              this.behaviourAssessment.length < 16
                ? this.behaviourAssessment.length
                : 15;
            const hasBehaviorFunctions =
              (this.behavior?.behaviorFunction?.length ?? 0) > 0;
            // Assessment fully answered but functions not yet saved: resume on the
            // Screener Result step. getGraphData() loads graphData + selectedOptions
            // and resolves the step (Escape/Attention level question first if needed).
            // if (
            //   this.currentQuestion === 15 &&
            //   this.mode !== InsightMode.EDIT &&
            //   !hasBehaviorFunctions
            // ) {
            //   this.isFinalStep = true;
            //   this.stepNumber = 0;
            // }
            // No mode check: "Continue to Assess" always opens in EDIT mode.
            if (
              this.behaviourAssessment.length === 16 &&
              !hasBehaviorFunctions
            ) {
              this.getGraphData();
            }
          }
        },
        error: error => {
          this.loaderService.hide();
          this.commonService.notify('error', error.message);
        },
      });
  }
  get generateRandomId(): string {
    const randomId = Math.floor(100000 + Math.random() * 900000); //NOSONAR - Safe for generating chart IDs, not security-sensitive
    return randomId.toString();
  }

  getBehaviourQuestionList() {
    this.loaderService.show();
    this.insightService
      .getBehvaiourAssessmentLookup()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: response => {
          if (response.result) {
            this.fbaQuestionList =
              response.result.functionalAssessmentQuestions;
            this.addQuestions();
          }
          this.getBehaviourAssessment();
        },
        error: error => {
          this.loaderService.hide();
          this.commonService.notify('error', error.message);
        },
      });
  }

  patchFormWithAnswers() {
    const answers = this.behaviourAssessment;
    // Iterate over the answers array to patch the form
    for (const answerData of answers) {
      const { functionalAssessmentQuestionId, functionalAssessmentAnswerId } =
        answerData;

      // Find the corresponding form group for the question
      const questionControl = this.questions.controls.find(
        group =>
          group.value.functionalAssessmentQuestionId ===
          functionalAssessmentQuestionId
      );
      // If the question is found, patch its 'answer' field
      if (questionControl) {
        questionControl.patchValue({
          functionalAssessmentAnswerId: functionalAssessmentAnswerId,
        });
      }
    }
  }

  async getMasterData() {
    this.loaderService.show();
    await Promise.all([
      this.commonService.getDataByType('BehaviourFunction').toPromise(),
    ])
      .then(
        ([BehaviourFunctionList]: [ApiResponses<LookupItem> | undefined]) => {
          this.BehaviourFunctionList = BehaviourFunctionList
            ? BehaviourFunctionList.result
            : [];
          const selectedBehaviorFuncations = this.behavior.behaviorFunction;
          if (
            selectedBehaviorFuncations &&
            selectedBehaviorFuncations.length > 0
          ) {
            const behaviorFunctionIds = selectedBehaviorFuncations.map(
              item => item.behaviorFunctionId
            );
            this.functionalAssessmentForm.patchValue({
              selectedOptions: behaviorFunctionIds,
            });

            this.stepNumber = 4;
            this.isEdit = true;
          } else if (
            this.graphData.length > 0 &&
            !this.functionalAssessmentForm.value.selectedOptions?.length
          ) {
            // Graph data resolved before the function lookup — re-map suggested functions
            this.updateSelectedOptions(this.getSortedSystemSuggestedData());
          }
          this.loaderService.hide();
        }
      )
      .catch(() => this.loaderService.hide())
      .finally(() => this.loaderService.hide());
  }

  get questions(): FormArray {
    return this.functionalAssessmentForm.get('questions') as FormArray;
  }

  get behaviorQuestionControl(): FormGroup[] {
    return this.questions?.controls as FormGroup[];
  }

  // Purely template-driven: skips Strategy if the template excludes it, landing on Data instead;
  // null (no continue button) if both Strategy and Data are excluded. Completion state (e.g.
  // strategies already applied) plays no part in this decision.
  get nextContinueTile(): BipTileSection | null {
    return this.bipTemplateGatingService.resolveNextIncludedTile(
      this.bipTemplate,
      BipTileSection.Assessment
    );
  }
  // Add the questions and answers to the form array
  addQuestions() {
    this.fbaQuestionList.forEach(question => {
      const questionGroup = this.fb.group({
        functionalAssessmentQuestionId: [question.id],
        functionalAssessmentAnswerId: [null, Validators.required], // Default answer (could be null or empty string)
      });

      // Adding each question's FormGroup to the form array
      this.questions.push(questionGroup);
    });
  }

  edit() {
    this.isEdit = false;
    this.stepNumber = 0;
    this.currentQuestion = 0;
    this.isFinalStep = false;
  }

  getFuncations() {
    const formArray: number[] =
      this.functionalAssessmentForm.value.selectedOptions;
    return _.chain(this.BehaviourFunctionList)
      .filter(option => _.includes(formArray, option.id))
      .map('value')
      .value();
  }

  getFuncationsString() {
    return this.getFuncations().join(', ');
  }

  getLevelFuncations(funcationVal: string, value: string) {
    if (value === 'Both') {
      const both = _.chain(this.BehaviourFunctionList)
        .filter(
          record =>
            (_.includes(record.value, 'Peers') ||
              _.includes(record.value, 'Adults')) &&
            _.includes(record.value, funcationVal)
        )
        .map('id')
        .value();
      const currentSelectedOptions =
        this.functionalAssessmentForm.value.selectedOptions || [];
      // Merge both arrays, ensuring there are no duplicates
      const updatedSelectedOptions = _.uniq([
        ...currentSelectedOptions,
        ...both,
      ]);
      this.functionalAssessmentForm.patchValue({
        selectedOptions: updatedSelectedOptions,
      });
    } else {
      const selected = _.chain(this.BehaviourFunctionList)
        .filter(
          record =>
            _.includes(record.value, value) &&
            _.includes(record.value, funcationVal)
        )
        .map('id')
        .value();

      const currentSelectedOptions =
        this.functionalAssessmentForm.value.selectedOptions || [];

      // Merge both arrays, ensuring there are no duplicates
      const updatedSelectedOptions = _.uniq([
        ...currentSelectedOptions,
        ...selected,
      ]);
      this.functionalAssessmentForm.patchValue({
        selectedOptions: updatedSelectedOptions,
      });
      this.functionalAssessmentForm.patchValue({
        selectedOptions: updatedSelectedOptions,
      });
    }
  }

  get isSaveBehaviouralFuncations(): boolean {
    return this.stepNumber === 3;
  }
  onContinue() {
    this.isContinueProcessing = true;
    this.submit();
  }

  submit() {
    if (this.isSaveBehaviouralFuncations) {
      // Audit: compare previous and new behaviorFunctionIds
      const oldIds: number[] = (this.behavior.behaviorFunction || []).map(
        f => f.behaviorFunctionId
      );
      const newIds: number[] =
        this.functionalAssessmentForm.value.selectedOptions || [];
      const allIds = Array.from(new Set([...oldIds, ...newIds]));
      const idToName = (id: number) => {
        const found = this.BehaviourFunctionList.find(f => f.id === id);
        return found ? found.value : `Function ${id}`;
      };
      const modifiedFields = allIds
        .filter(id => oldIds.includes(id) !== newIds.includes(id))
        .map(id => ({
          field: `Behavior Function`,
          label: idToName(id),
          oldValue: oldIds.includes(id) ? idToName(id) : null,
          newValue: newIds.includes(id) ? idToName(id) : null,
        }));
      const payload = {
        caseBehaviorId: this.behavior.id,
        isAssessedFunctions:
          this.functionalAssessmentForm.value.isAssessedFunctions,
        behaviorFunctionIds:
          this.functionalAssessmentForm.value.selectedOptions,
        _modifiedFields: modifiedFields,
      };
      this.saveBehaviouralfuncations(payload);
    } else {
      const currentControl = this.questions.at(this.currentQuestion).value;
      if (currentControl.functionalAssessmentAnswerId) {
        const oldAnswers = this.behaviourAssessment || [];
        const newAnswers = this.functionalAssessmentForm.value.questions || [];
        const modifiedFields = this.getAssessmentModifiedFields(
          oldAnswers,
          newAnswers
        );
        const payload = {
          caseBehaviorId: this.behavior.id,
          functionalAssessmentAnswers: newAnswers,
          _modifiedFields: modifiedFields,
        };
        this.saveBehaviouralAssessment(payload, false);
        this.isUpdated = true;
      }
    }
  }
  isCurrentStepValid(): boolean {
    switch (this.stepNumber) {
      case 0:
        return (
          this.questions.length > 0 &&
          this.questions.at(this.currentQuestion).valid
        );
      case 1: {
        const { isLevelEscap, levelEscape } =
          this.functionalAssessmentForm.value;

        if (isLevelEscap && !levelEscape) return false;

        return true;
      }
      case 2: {
        const { isLevelEscap, levelEscape, isLevelAttention, levelAttention } =
          this.functionalAssessmentForm.value;

        if (isLevelAttention > 0 && !levelAttention) return false;
        else if (isLevelEscap > 0 && isLevelAttention > 0) {
          if (!levelEscape || !levelAttention) {
            return false; // Condition fails
          }
        }
        return true;
      }
      case 3:
        return this.functionalAssessmentForm.value.selectedOptions.length > 0;
      default:
        return false;
    }
  }
  goToNext() {
    switch (this.stepNumber) {
      case 0:
        this.handleStep0Next();
        break;
      case 1:
        this.handleStep1Next();
        break;
      case 2:
        this.handleStep2Next();
        break;
      case 3:
        this.handleStep3Next();
        break;
    }
  }

  private handleStep0Next(): void {
    const currentControl = this.questions.at(this.currentQuestion).value;
    if (!currentControl.functionalAssessmentAnswerId) {
      return;
    }

    if (this.currentQuestion < this.fbaQuestionList.length - 1) {
      this.currentQuestion++;
      if (this.currentQuestion === this.fbaQuestionList.length - 1) {
        this.isFinalStep = true;
      } else {
        this.saveForLater(true);
      }
    } else {
      this.stepNumber = 3;
      this.isFinalStep = true;
    }
  }

  private handleStep1Next(): void {
    if (this.functionalAssessmentForm.value.levelEscape) {
      this.getLevelFuncations(
        BehaviourFunction.ESCAPE_AVOIDANCE,
        this.functionalAssessmentForm.value.levelEscape
      );
    }
    const hasLevelAttention =
      this.functionalAssessmentForm.value.isLevelAttention;
    this.stepNumber = hasLevelAttention ? 2 : 3;
    this.isFinalStep = !hasLevelAttention;
  }

  private handleStep2Next(): void {
    if (this.functionalAssessmentForm.value.levelAttention) {
      this.getLevelFuncations(
        BehaviourFunction.GAINING_ATTENTION,
        this.functionalAssessmentForm.value.levelAttention
      );
    }
    this.stepNumber = 3;
    this.functionalAssessmentForm.patchValue({
      isAssessedFunctions: true,
    });
    this.isFinalStep = true;
  }

  private handleStep3Next(): void {
    this.isFinalStep = true;
  }

  goToPre() {
    this.isFinalStep = false;
    switch (this.stepNumber) {
      case 0: {
        if (this.currentQuestion > 0) {
          this.currentQuestion--;
        } else {
          this.stepNumber = 0;
          this.currentQuestion = 0;
        }
        break;
      }
      case 1: {
        this.stepNumber = 0;
        this.currentQuestion = this.fbaQuestionList.length - 1;
        this.isFinalStep = true;
        break;
      }
      case 2: {
        if (this.functionalAssessmentForm.value.isLevelEscap) {
          this.stepNumber = 1;
          this.isFinalStep = false;
        } else {
          this.stepNumber = 0;
          this.currentQuestion = this.fbaQuestionList.length - 1;
          this.isFinalStep = true;
        }
        break;
      }
      case 3: {
        if (this.functionalAssessmentForm.value.isLevelAttention) {
          this.stepNumber = 2;
          this.isFinalStep = false;
        } else if (this.functionalAssessmentForm.value.isLevelEscap) {
          this.stepNumber = 1;
          this.isFinalStep = false;
        } else {
          this.stepNumber = 0;
          this.isFinalStep = true;
        }
      }
    }
  }
  resetPage() {
    this.functionalAssessmentForm.reset();
    this.currentQuestion = 0;
    this.stepNumber = 0;
    this.isFinalStep = false;
  }

  onCancel() {
    this.resetPage();
    const drawer = this.drawerService.getDrawerRef(DRAWER_IDS.FBA);

    if (this.isContinueProcessing) {
      drawer?.close({ navigationHandled: true, isContinueProcessing: true });
      this.drawerService.closeDrawer(DRAWER_IDS.DEFINE_BEHAVIOR);
      if (this.nextContinueTile === BipTileSection.Data) {
        this.openDataDrawer(this.behavior);
      } else {
        this.openManageBehaviorStrategiesDrawer(this.behavior);
      }
    } else {
      drawer?.close({
        navigationHandled: true,
        assessmentData: this.isUpdated ? null : this.behaviourAssessment,
        isContinueProcessing: false,
      });
    }
  }
  openManageBehaviorStrategiesDrawer(behavior: CaseBehaviour): void {
    this.drawerService
      .openDrawer(
        ManageBehaviorStrategiesComponent,
        this.drawerTitleBehaviorStrategies as unknown as TemplateRef<object>,
        1170,
        true,
        undefined,
        {
          case: this.caseDetail,
          behavior: behavior,
          mode: InsightMode.VIEW,
          orgId: this.caseDetail?.student?.organizationId,
          isContinueProcessing:
            !behavior.appliedStrategyCount ||
            behavior.appliedStrategyCount === 0,
        },
        DRAWER_IDS.MANAGE_BEHAVIOR_STRATEGIES
      )
      .afterClose.pipe(takeUntil(this.destroy$))
      .subscribe(result => {
        const drawerResult = result as
          | { navigationHandled?: boolean }
          | undefined;

        if (drawerResult?.navigationHandled) {
          return;
        }
      });
  }

  closeManageBehaviorStrategiesDrawer(): void {
    this.drawerService.closeDrawer(DRAWER_IDS.MANAGE_BEHAVIOR_STRATEGIES);
  }

  openDataDrawer(behavior: CaseBehaviour): void {
    this.drawerService
      .openDrawer(
        InsightsDataComponent,
        this.drawerTitleData as unknown as TemplateRef<object>,
        1170,
        true,
        undefined,
        {
          case: this.caseDetail,
          behavior,
          mode: InsightMode.VIEW,
          orgId: this.caseDetail?.student?.organizationId,
          caseBehaviorId: behavior.id,
          isContinueProcessing: false,
        },
        DRAWER_IDS.MANAGE_DATA
      )
      .afterClose.pipe(takeUntil(this.destroy$))
      .subscribe();
  }

  closeDataDrawer(): void {
    this.drawerService.closeDrawer(DRAWER_IDS.MANAGE_DATA);
  }

  saveBehaviouralfuncations(payload: BehaviorFuncation) {
    this.loaderService.show();
    const operation$ = this.insightService.submitBehaviourFuncation(payload);
    operation$
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        finalize(() => {
          this.loaderService.hide();
        })
      )
      .subscribe({
        next: () => {
          this.isUpdated = true;
          this.commonService.notify(
            'success',
            `The behavior screener has been saved.`
          );
          this.insightService.assessmentSubject.next([]);
          this.onCancel();
        },
        error: (error: ErrorResponse) => {
          this.loaderService.hide();
          this.handleError(error);
        },
      });
  }

  saveBehaviouralAssessment(
    payload: FunctionalAssessmentModelResponse,
    isNext = false
  ) {
    if (isNext) {
      this.loaderService.hide();
      this.isNextLoading = true;
    } else {
      this.loaderService.show();
    }
    const operation$ = this.insightService.submitBehaviouralAssessment(payload);
    operation$.pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: () => {
        if (this.currentQuestion === 15 && this.stepNumber === 0) {
          this.insightService.assessmentSubject.next(this.behaviourAssessment);
          setTimeout(() => {
            this.getGraphData();
          }, 800);
        } else if (!isNext) {
          this.onCancel();
        }
        this.loaderService.hide();
        this.isNextLoading = false;
      },
      error: error => {
        this.loaderService.hide();
        this.isNextLoading = false;
        if (!isNext) {
          this.handleError(error);
        }
      },
    });
  }

  checkActivityLevel() {
    return _.orderBy(
      _.filter(this.graphData, item =>
        [
          BehaviourFunction.ESCAPE_AVOIDANCE as string,
          BehaviourFunction.GAINING_ATTENTION as string,
        ].includes(item.behaviourFunctionName)
      ),
      ['score'],
      ['desc']
    );
  }

  updateFormWithScore(
    result: BehaviouralAssessmentGraphData[],
    behaviourFunction: string,
    formKey: string,
    value: boolean
  ) {
    const filteredData = _.filter(result, item =>
      [behaviourFunction].includes(item.behaviourFunctionName)
    );

    if (filteredData.length > 0) {
      this.functionalAssessmentForm.patchValue({
        [formKey]: value,
      });
    }
  }

  getGraphData() {
    this.loaderService.show();
    this.insightService
      .getBehvaiourGraphData(this.behavior.id)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => this.loaderService.hide())
      )
      .subscribe({
        next: response => {
          if (response.result) {
            this.graphData = response.result;
            this.processGraphDataResponse();
          }
        },
        error: (error: ErrorResponse) => {
          this.handleError(error);
        },
      });
  }

  private processGraphDataResponse(): void {
    const sortedData = this.getSortedSystemSuggestedData();
    this.updateSelectedOptions(sortedData);

    const filteredResult = this.getFilteredBehaviorFunctionData(sortedData);
    if (filteredResult.length > 0) {
      this.processFilteredBehaviorFunctions(filteredResult);
      this.stepNumber = this.determineStepNumber();
      this.isFinalStep = false;
    } else {
      this.stepNumber = 3;
      this.isFinalStep = true;
    }
  }

  private getSortedSystemSuggestedData(): BehaviouralAssessmentGraphData[] {
    return _.orderBy(
      _.filter(this.graphData, item => item.isSystemSuggested),
      ['score'],
      ['desc']
    );
  }

  private updateSelectedOptions(
    sortedData: BehaviouralAssessmentGraphData[]
  ): void {
    const selectedOptions = sortedData.map(data => {
      return _.chain(this.BehaviourFunctionList)
        .filter(record => record.value === data.behaviourFunctionName)
        .map('id')
        .value();
    });
    this.functionalAssessmentForm.patchValue({
      selectedOptions: selectedOptions.flat(),
    });
  }

  private getFilteredBehaviorFunctionData(
    sortedData: BehaviouralAssessmentGraphData[]
  ): BehaviouralAssessmentGraphData[] {
    return _.orderBy(
      _.filter(sortedData, item =>
        [
          BehaviourFunction.ESCAPE_AVOIDANCE as string,
          BehaviourFunction.GAINING_ATTENTION as string,
        ].includes(item.behaviourFunctionName)
      ),
      ['score'],
      ['desc']
    );
  }

  private processFilteredBehaviorFunctions(
    result: BehaviouralAssessmentGraphData[]
  ): void {
    const hasEscapeAvoidance = result.some(
      item => item.behaviourFunctionName === BehaviourFunction.ESCAPE_AVOIDANCE
    );
    const hasGainingAttention = result.some(
      item => item.behaviourFunctionName === BehaviourFunction.GAINING_ATTENTION
    );

    if (hasEscapeAvoidance) {
      this.updateFormWithScore(
        result,
        BehaviourFunction.ESCAPE_AVOIDANCE,
        'isLevelEscap',
        true
      );
    }

    if (hasGainingAttention) {
      this.updateFormWithScore(
        result,
        BehaviourFunction.GAINING_ATTENTION,
        'isLevelAttention',
        true
      );
    }
  }

  private determineStepNumber(): number {
    if (this.functionalAssessmentForm.value.isLevelEscap) {
      return 1;
    } else if (this.functionalAssessmentForm.value.isLevelAttention) {
      return 2;
    } else {
      return 3;
    }
  }

  private handleError({ errors, message }: ErrorResponse): void {
    const errorMessages = errors.map(
      err => err.description || err.detailedMessage
    );
    this.commonService.notify('error', errorMessages, message);
  }

  addIsSelected(
    questions: FunctionalAssessmentQuestion[],
    selectedAnswers: FunctionalAssessmentModelAnswer[]
  ) {
    return questions.map(question => {
      // Check if the question has selected answers
      const selectedAnswer = selectedAnswers.find(
        selected => selected.functionalAssessmentQuestionId === question.id
      );

      // Update the answers with the `isSelected` property
      question.functionalAssessmentAnswers =
        question.functionalAssessmentAnswers.map(answer => ({
          ...answer,
          isSelected: selectedAnswer
            ? answer.id === selectedAnswer.functionalAssessmentAnswerId
            : false,
        }));

      return question;
    });
  }
  async print() {
    this.stepNumber = 4;
    this.isFinalStep = false;
    const updatedQuestions = this.addIsSelected(
      this.fbaQuestionList,
      this.behaviourAssessment
    );
    const factory = this.viewContainerRef.createComponent(PrintFbaComponent, {
      injector: this.injector,
    });
    const componentElement = factory.location.nativeElement;
    componentElement.style.display = 'none';
    this.isPrintLoading = true;
    await Promise.all([
      this.orgService
        .getOrganization(this.caseDetail?.student.organizationId)
        .toPromise(),
    ])
      .then(async ([orgRes]: [OrganizationModel | undefined]) => {
        let base64Image = '';
        if (orgRes?.logoUrl) {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            orgRes.logoUrl
          );
        } else {
          base64Image = await this.commonService.getBase64ImageFromUrl(
            '/assets/images/logo.png'
          );
        }
        factory.instance.fbaData = {
          behaviorAssessmentList: updatedQuestions,
          logo: base64Image,
          caseDetail: this.caseDetail,
          graphData: this.behavior.behaviorAssessmentGraph,
          chartImage: this.chartImage,
          orgDetail: orgRes,
          assesupdatedDate: this.assesupdatedDate,
        };
        this.cd.detectChanges();
        this.waitForInitialization(factory).then(() => {
          factory.instance.printPDF();
        });
      })
      .catch(e => console.error(e))
      .finally(() => {
        this.isPrintLoading = false;
        this.cd.detectChanges();
      });
  }

  waitForInitialization(factory: ComponentRef<PrintFbaComponent>) {
    return new Promise<void>(resolve => {
      const interval = setInterval(() => {
        if (factory.instance.initialized) {
          clearInterval(interval);
          resolve();
        }
      }, 10);
    });
  }

  saveForLater(isNext = false) {
    if (!this.allowManageAssessment) {
      return;
    }
    const filteredAnswers =
      this.functionalAssessmentForm.value.questions.filter(
        (q: FunctionalAssessmentModelAnswer) =>
          q.functionalAssessmentAnswerId !== null
      );
    const oldAnswers = this.behaviourAssessment || [];
    const newAnswers = filteredAnswers;
    const modifiedFields = this.getAssessmentModifiedFields(
      oldAnswers,
      newAnswers
    );
    const payload = {
      caseBehaviorId: this.behavior.id,
      functionalAssessmentAnswers: filteredAnswers,
      _modifiedFields: modifiedFields,
    };
    this.saveBehaviouralAssessment(payload, isNext);
  }
}
